module.exports = __webpack_public_path__ + "static/media/about-us.52bec8f6.png";